// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ruxnmbdfhqwdqhxrxasr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ1eG5tYmRmaHF3ZHFoeHJ4YXNyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM1NzQ2NjEsImV4cCI6MjA1OTE1MDY2MX0.WQXPKH0jp1W2Jiw6PPO17wOaqlvDXRtUSVQyET7zbkY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);